<template lang="html">
  <transition-group class="snackbar" name="snackbar" tag="ul">
    <li v-for="toast in $store.state.application.toasts" class="toast" :key="toast.id">
      <Toast :action="toast.action" :action-label="toast.actionLabel" :message="toast.message" :timeout="toast.timeout" @remove="$store.commit('removeToast', toast.id)" />
    </li>
  </transition-group>
</template>

<script>
import Toast from './Toast.vue';

export default {
  components: {
    Toast,
  },
};
</script>

<style lang="stylus" scoped>
.snackbar
  position: fixed
  top: 8px
  width: calc(100% - 16px)
  max-width: 624px
  list-style: none
  padding: 0
  margin: 0 8px
  z-index: 10

  .snackbar-move
    transition: transform 350ms ease

  .snackbar-enter-active
    transition: transform 350ms cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 200ms ease

    &.snackbar-enter
      transform: translateY(-64px)
      opacity: 0

  .snackbar-leave-active
    transition: transform 350ms cubic-bezier(0.6, -0.28, 0.735, 0.045)
    position: absolute
    width: 100%
    z-index: 2

    &.snackbar-leave-to
      transform: translateX(100%)

</style>
